import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/**
 * Material Code/Name Cell Renderer
 *
 * Displays material information:
 * - Material code (bold, small font)
 * - Material name (below, uppercase)
 *
 * Generic renderer that can work with any data structure
 * containing material.code and material.name
 */
@Component({
  selector: 'app-material-codename-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="truncate">
      <span class="block truncate font-bold text-[10px]">{{ code }}</span>
      <span class="block truncate text-xs uppercase">{{ name }}</span>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialCodeNameCellRendererComponent implements CellRenderer<any> {
  @Input() params!: CellRendererParams<any>;

  get code(): string {
    return this.params?.data?.material?.code || '-';
  }

  get name(): string {
    return this.params?.data?.material?.name || '';
  }
}
